export default __webpack_public_path__ + "static/media/kangoo-gallery-3.836dd6e1.jpg";